import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

type StyledTypography = {
  fontWeight: 300 | 700;
};

const StyledTypography = styled.span<StyledTypography>`
  color: inherit;
  font-weight: ${({ fontWeight }) => fontWeight};
`;

const Logo: FunctionComponent = () => {
  return (
    <>
      <StyledTypography fontWeight={300}>CLUB</StyledTypography>
      <StyledTypography fontWeight={700}>FINDER</StyledTypography>
    </>
  );
};

export default Logo;
